import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ClinicDoctorsPage } from './clinic-doctors';
import { DirectivesModule } from '../../directives/directives.module';

@NgModule({
  declarations: [
    ClinicDoctorsPage,
  ],
  imports: [
    IonicPageModule.forChild(ClinicDoctorsPage),
    DirectivesModule
  ],
})
export class ClinicDoctorsPageModule {}



// WEBPACK FOOTER //
// ./src/pages/clinic-doctors/clinic-doctors.module.ts